<template lang="pug">
linked-tabs.notificationsLinkedTabs
  linked-tabs-item(:to="localePath('messages')")
    fa-icon(:icon="['fal', 'envelope']")
    span {{ $t('pages.messages') }}
    span.notificationsLinkedTabs__count(v-if="messagesUnreadCount") {{ messagesUnreadCount.toLocaleString() }}
  linked-tabs-item(:to="localePath('announcement')")
    fa-icon(:icon="['fal', 'megaphone']")
    span {{ $t('pages.announcement') }}
    span.notificationsLinkedTabs__count(v-if="announcementUnreadCount") {{ announcementUnreadCount.toLocaleString() }}
</template>

<script>
const LinkedTabs = () => import('@/components/organisms/LinkedTabs')
const LinkedTabsItem = () => import('@/components/molecules/LinkedTabsItem')

export default {
  components: { LinkedTabs, LinkedTabsItem },
  props: {
    messagesUnreadCount: { type: Number, default: () => 0 },
    announcementUnreadCount: { type: Number, default: () => 0 },
  },
}
</script>

<style lang="scss" scoped>
.notificationsLinkedTabs {
  .linkedTabsItem {
    span {
      font-size: 0.75rem;

      @media (min-width: $breakpoint) {
        font-size: 1.2rem;
      }
    }
  }

  &__count {
    background: #d63031;
    border-radius: 1rem;
    color: #fff;
    display: inline-block;
    font-family: Oswald;
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 1;
    margin-left: 0.5rem;
    padding: 0.5rem 1rem;

    @media (min-width: $breakpoint) {
      font-size: 1rem;
      margin-left: 1rem;
    }
  }
}
</style>
